import moment from 'moment'
import React,{useState,useEffect} from 'react'
import { assetUrl } from '../../helpers'
import { Attendance } from '../../sdk'
import { Loader } from '../Default'
import { useAuthContext } from '../../context/Auth/Create'
export const MainContent=()=> {
  const [state,setState]=useState({loader:true,data:[]});
  const userAuth=useAuthContext();
  const apiData=async()=>{
    try{
    let result=await new Attendance().getLiveAttendance();
    setState((pre)=>{
      return {...pre,data:result,loader:false}
    })

   
    }catch(e){
    alert("error occur")
    }

}


useEffect(()=>{
  apiData();
  userAuth.socket.on('getAttendance',apiData)
  return ()=>{
  userAuth.socket.off('getAttendance',apiData)
  }
  // const setTime=setInterval(()=>apiData(),1000 *5)
  // return ()=>{
  //   clearInterval(setTime);
  // }
  
 

},[])
if(!state.loader){
return (
  <>
  <div className="card mb-3">
   {/* BEGIN card-body */}
   <div className="card-body">
<div className="col-12">
 <div className="row mb-4" style={{textAlign:"center"}}>
   <div className="col-12">
   <div className="fw-bold mb-3">
<span className="flex-grow-1 text-white">Live Attendance</span>
</div> 
   </div>
   <div className="col-12">
    <div className="row" style={{display:"flex",justifyContent:"space-between"}}>
      <div className="col-2"></div>
      <div className="col-2"></div>
    <div className="col-2" style={{background:"green",width:"15%",paddingTop: "5px"}}> <h6>CheckIn</h6></div>
   <div className="col-2" style={{background:"red",width:"15%",paddingTop: "5px"}}> <h6>Checkout</h6></div>
   <div className="col-2"></div>
      <div className="col-2"></div>
    </div>
   </div>
  
  
 </div>

</div>

<div className="col-12">
<div className="row">
<div className="col-12 col-md-12 col-lg-12">
  <div className="row">
  <div id="images" className="mb-5">


  <div className="row">
    {state.data.map((val,index)=>{
      let background="green";
      if(val.eventType==="checkout"){
background="red"
      }
      return <>
      <div className="col-xl-2">
      
      <div className="card mb-3">
        <div className="card-body pb-0">
          <img
            src={`${assetUrl}${val.frontImageUrl}`}
            alt=""
            className="card-img-top"
            style={{maxHeight:"200px",minHeight:"200px"}}
          />
        </div>
        <div className="card-body" style={{textAlign:"center"}}>
          <h5 className="card-title" style={{maxHeight:"43px",minHeight:"43px"}}>{val.employeeName}</h5>
          <h6>ID : {val.employeeId}</h6>
         <p className="card-text" style={{background}}>
          Time : {moment(val.createdAt).format("HH:mm:ss")}
          </p>
        </div>
        <div className="card-arrow">
          <div className="card-arrow-top-left" />
          <div className="card-arrow-top-right" />
          <div className="card-arrow-bottom-left" />
          <div className="card-arrow-bottom-right" />
        </div>
      </div>
    </div>
      </>
    })}
    
   
    
   
 


</div>
</div>

  </div>


</div>

</div>
</div>


</div>
<div className="card-arrow">
     <div className="card-arrow-top-left" />
     <div className="card-arrow-top-right" />
     <div className="card-arrow-bottom-left" />
     <div className="card-arrow-bottom-right" />
   </div>
</div>
<div class="modal" id="showImg">
<div class="modal-dialog modal-xl">
<div class="modal-content">
  
  <div class="modal-body">
   <img id="modalImage" src='' alt="nothing" style={{width:"100%"}}/>
  </div>
 
</div>
</div>
</div>


</>
 
    
   )
}
else{
  return (<>
  <Loader/>
  </>)
}
  
}